import { Modal } from 'antd';
import React, { useState } from 'react'
import Sertificate1 from "../../Assets/Images/sertificate1.jpg"
import Sertificate2 from "../../Assets/Images/sertificate2.jpg"
import Sertificate3 from "../../Assets/Images/sertificate3.jpg"
import Sertificate4 from "../../Assets/Images/sertificate4.jpg"
import Sertificate5 from "../../Assets/Images/sertificate5.jpg"

function Sertificate() {
  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = (e) => {
    setOpen(false);
  };
  const handleCancel = (e) => {
    setOpen(false);
  };
  const [imageId, setImageId] = useState(null)
  const clickedImage = (evt) => {
    setImageId(evt.target.id)
    showModal()
  }

  return (
    <section className='py-10 bg-[#6656C1]'>
      <div className='mx-auto px-5 '>
        <div className=''>
          <div className='flex flex-col sm:flex-row items-center justify-center sm:space-x-3 lg:space-x-20'>
            <ul className='flex lg:flex-row items-center justify-between space-x-3 lg:space-x-20'>
              <li data-aos="zoom-in-up" onClick={clickedImage} id='1' className='cursor-pointer'>
                <img className='rounded-md w-[400px] sm:w-[300px]' id='1' src={Sertificate1} width={'100%'} height={'100%'} alt='sertificate' />
              </li>
              <li data-aos="zoom-in-up" onClick={clickedImage} id='2' className=' cursor-pointer'>
                <img className='rounded-md w-[400px] sm:w-[300px]' id='2' src={Sertificate5} width={'100%'} height={'100%'} alt='sertificate' />
              </li>
              <li data-aos="zoom-in-up" onClick={clickedImage} id='3' className=' cursor-pointer'>
                <img className='rounded-md sm:rotate-[90deg] w-[400px] sm:w-[250px]' id='3' src={Sertificate2} width={'100%'} height={'100%'} alt='sertificate' />
              </li>
            </ul>
            <ul className='flex items-center mt-5 sm:mt-0 justify-between space-x-3 lg:space-x-20'>
              <li data-aos="zoom-in-up" onClick={clickedImage} id='4' className=' cursor-pointer'>
                <img className='rounded-md w-[400px] sm:w-[300px] ' id='4' src={Sertificate4} width={'100%'} height={'100%'} alt='sertificate' />
              </li>
              <li data-aos="zoom-in-up" onClick={clickedImage} id='5' className=' cursor-pointer'>
                <img className='rounded-md w-[400px] sm:w-[300px] ' id='5' src={Sertificate3} width={'100%'} height={'100%'} alt='sertificate' />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Modal
        className=' p-5 rounded-lg'
        open={open}
        width={600}
        height={600}
        onOk={handleOk}
        onCancel={handleCancel}
        okButtonProps={{
          disabled: true,
        }}
        cancelButtonProps={{
          disabled: true,
        }}
      >
        {imageId === "1" && <img className='scale-[1.1] sm:scale-[1.7] mt-10 sm:mt-20 rounded-md' id='1' src={Sertificate1} width={'400px'} height={'100px'} alt='sertificate' />}
        {imageId === "2" && <img className='scale-[1.1] sm:scale-[1.2] -mt-5 rounded-md' id='1' src={Sertificate5} width={'800px'} height={'800px'} alt='sertificate' />}
        {imageId === "5" && <img className='scale-[1] sm:scale-[1.5] sm:mt-16 rounded-md' id='1' src={Sertificate3} width={'400px'} height={'100px'} alt='sertificate' />}
        {imageId === "4" && <img className='scale-[1] sm:scale-[1.5] sm:mt-16 rounded-md' id='1' src={Sertificate4} width={'400px'} height={'100px'} alt='sertificate' />}
        {imageId === "3" && <img className='scale-[0.8] rotate-[90deg] sm:scale-[1.7] sm:mt-24 rounded-md' id='1' src={Sertificate2} width={'400px'} height={'100px'} alt='sertificate' />}
      </Modal>
    </section>
  )
}

export default Sertificate